import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, Button } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { BASE_URL } from '../../../store/config';
import { getObjByName } from '../../../common/utils';
import instance from '../../../request/http';
import Toast from '../../Layout/components/Toast';
import UserAutoComplete from '../../Components/UserAutoComplete';
import { Add } from '@material-ui/icons';

const Root = styled(Box)({
    width: '801px',
    padding: '24px',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textField': {
        width: '100%'
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .leaderTitle': {
        fontWeight: 'bold',
        color: '#0060A0',
        margin: '16px 0',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .members': {
        height: '265px',
        '& .member': {
            width: '48%',
            height: '100%',
            padding: '10px 20px',
            // backgroundColor: '#F2F0F3',
            border: '1px solid #c4c4c4',
            borderRadius: '4px',
        },
        '& .textField': {
            marginRight: '13px',
            backgroundColor: '#fff',
        },
    },
    '& .teamList': {
        height: '70%',
        overflow: 'auto',
        '& .item': {
            padding: '9px 0',
            borderBottom: '1px dashed #D8D8D8',
        },
        '& .delWapper': {
            cursor: 'pointer',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .addBtn': {
        marginLeft: '13px',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
const LEADER = "team_leader";
const MEMBER = "staff";
class TeamInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            description: "",
            leader: null,
            member: null,
            selectLeaders: [],
            selectMembers: [],
            users: [
                {
                    id: 0,
                    first_name: "",
                    last_name: "",
                }
            ],
            leaderId: 0,
            memberId: 0,
            team_id: 0,

            showToast: false,
            toastMsg: "",
            toastState: "",
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDelet = this.handleDelet.bind(this);
        this.handleAddLeader = this.handleAddLeader.bind(this);
        this.handleAddMember = this.handleAddMember.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.updateMember = this.updateMember.bind(this);
        this.updateLeader = this.updateLeader.bind(this);
    }
    render() {
        const { data, title, state } = this.props;
        const {
            name,
            description,
            leader,
            users,
            member,
            selectLeaders,
            selectMembers,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const addMemberView = () => {
            if (state !== VIEW) {
                return <div>
                    <div><b>Leader List</b></div>
                    <div className="h h-c">
                        <UserAutoComplete
                            initUser={member}
                            update={this.updateMember}
                        />
                        <Button disabled={this.isDisabled()} className="addBtn" variant="contained" color="primary" onClick={this.handleAddLeader}>ADD</Button>
                    </div>
                </div>
            } else {
                return <div><b>Member List</b></div>
            }
        }
        const addLeaderView = () => {
            if (state !== VIEW) {
                return <div>
                    <div><b>Leader List</b></div>
                    <div className="h h-c">
                        <UserAutoComplete
                            initUser={leader}
                            update={this.updateLeader}
                        />
                        <Button disabled={this.isDisabled()} className="addBtn" variant="contained" color="primary" onClick={this.handleAddLeader}>ADD</Button>
                    </div>
                </div>
            } else {
                return <div><b>Leader List</b></div>
            }
        }
        const showCreateBtn = () => {
            if (!this.isDisabled()) {
                return <Button variant="contained" color="primary" onClick={this.handleCreate}>{this.btnName(this.props.state)}</Button>
            }
        }
        const leaderView = () => {
            if (!data) return;
            const roleName = data.role.name;
            if (roleName === LEADER) {
                return <div className="member">
                    <div className="h h-l">
                        <div className="leaderTitle">Team Leader</div>
                    </div>
                    <div className="teamList">
                        {selectLeaders.map((item) => (
                            <div key={item.id} className="item h h-bt">
                                <div>{item.first_name + " " + item.last_name}</div>
                            </div>
                        ))}
                    </div>
                </div>
            } else {
                return <div className="member">
                    {addLeaderView()}
                    <div className="teamList">
                        {selectLeaders.map((item) => (
                            <div key={item.id} className="item h h-bt">
                                <div>{item.first_name + " " + item.last_name}</div>
                                <div hidden={this.isDisabled()} className="delWapper" onClick={e => this.handleDelet(e, item, "leader")}>
                                    <DeleteForeverIcon className="del d-e"></DeleteForeverIcon>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            }
        }
        return (
            <Root>
                <div className="pageTitle">{title}</div>
                <div className="line"></div>
                <TextField
                    disabled={this.isTitleDisabled()}
                    className="textField"
                    id="outlined-name"
                    label="Team name"
                    value={name}
                    onChange={e => this.handleChange(e, 'name')}
                    margin="dense"
                    variant="outlined"
                />
                <TextField
                    disabled={this.isTitleDisabled()}
                    className="textField"
                    id="outlined-multiline-static"
                    label="Description"
                    multiline
                    rows="3"
                    value={description}
                    onChange={e => this.handleChange(e, 'description')}
                    margin="dense"
                    variant="outlined"
                />
                <div className="title">Team Members</div>
                <div className="members h h-bt">
                    {leaderView()}
                    <div className="member">
                        {addMemberView()}
                        <div className="teamList">
                            {selectMembers.map((item) => (
                                <div key={item.id} className="item h h-bt">
                                    <div>{item.first_name + " " + item.last_name}</div>
                                    <div hidden={this.isDisabled()} className="delWapper" onClick={e => this.handleDelet(e, item, "member")}>
                                        <DeleteForeverIcon className="del d-e"></DeleteForeverIcon>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="line"></div>
                <div className="foot h h-r">
                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                    {showCreateBtn()}
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
        // this.setDefaultData();
    }
    initData() {
        const { state } = this.props;
        this.getUsers(() => {
            this.getRole(() => {
                if (state !== ADD) {
                    this.setDefaultData();
                }
            });
        });
    }
    setDefaultData() {
        const { data } = this.props;
        let temporaryData = data;
        if (temporaryData === null) {
            temporaryData = {
                name: "",
                description: "",
                members: [],
                team_id: 0,
            }
        }
        this.setState(() => ({
            name: temporaryData.name,
            description: temporaryData.description,
            selectLeaders: this.filterRole(temporaryData.members, LEADER),
            selectMembers: this.filterRole(temporaryData.members, MEMBER),
            team_id: temporaryData.id,
        }))
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    isTitleDisabled() {
        const { data, state } = this.props;
        if (!data) return false;
        const roleName = data.role.name;
        if (roleName === LEADER) {
            if (state === ADD) {
                return false;
            } else if (state === VIEW) {
                return true;
            } else if (state === EDIT) {
                return true;
            }
        } else {
            if (state === ADD) {
                return false;
            } else if (state === VIEW) {
                return true;
            } else if (state === EDIT) {
                return false;
            }
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
    handleCreate() {
        const { name, description, selectLeaders, selectMembers } = this.state;
        let members = this.mergeLeaderMember(selectLeaders, selectMembers);
        let obj = {
            name,
            description
        }
        // console.log(members)
        this.props.handleCreate(obj, members);
    }
    handleCancel() {
        this.props.handleCancel();
    }
    //name和desc输入的内容
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleDelet(e, obj, name) {
        const { selectLeaders, selectMembers, team_id, leaderId, memberId } = this.state;
        const { state } = this.props;
        if (name === "leader") {
            if (state === EDIT) {//后台删除leader
                let members = [{ user_id: obj.id, role_id: leaderId }]
                this.delMember(members, team_id, () => {
                    this.removeSelectData(selectLeaders, "selectLeaders", obj)
                })
            } else {
                this.removeSelectData(selectLeaders, "selectLeaders", obj)
            }
        } else if (name === "member") {
            if (state === EDIT) {//后台删除member
                let members = [{ user_id: obj.id, role_id: memberId }]
                this.delMember(members, team_id, () => {
                    this.removeSelectData(selectMembers, "selectMembers", obj)
                })
            } else {
                this.removeSelectData(selectMembers, "selectMembers", obj)
            }
        }
    }
    handleAddLeader() {
        const { selectLeaders, leader, leaderId, team_id } = this.state;
        const { state } = this.props;
        this.addSelectData(selectLeaders, "selectLeaders", leader, (haveObj) => {
            if (haveObj) {
                if (state === EDIT) {//后台增加leader
                    let members = [{ user_id: leader.id, role_id: leaderId }]
                    this.addMember(members, team_id)
                }
            }
        })
    }
    handleAddMember() {
        const { selectMembers, member, memberId, team_id } = this.state;
        const { state } = this.props;
        this.addSelectData(selectMembers, "selectMembers", member, (haveObj) => {
            if (haveObj) {
                if (state === EDIT) {//后台增加member
                    let members = [{ user_id: member.id, role_id: memberId }]
                    this.addMember(members, team_id)
                }
            }
        })
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    updateMember(member) {
        this.setState(() => ({
            member
        }));
    }
    updateLeader(leader) {
        this.setState(() => ({
            leader
        }));
    }
    removeSelectData(arr, name, obj) {
        let index = arr.findIndex((element) => (element.id === obj.id));
        arr.splice(index, 1)
        this.setState(() => ({
            [name]: arr
        }))
    }
    //添加：选中的数据加到变量中交给父容器添加
    //修改：直接请求后台删改
    addSelectData(arr, name, selectObj, callback) {
        const { selectLeaders, selectMembers } = this.state;
        if (selectObj === "") {
            callback(false);
            return;
        };
        const obj1 = getObjByName(selectLeaders, "id", selectObj.id);
        const obj2 = getObjByName(selectMembers, "id", selectObj.id);
        if (obj1 || obj2) {
            this.showToast("Do not repeatedly select the same person", "error");
            callback(false);
            return;
        }
        arr.push(selectObj)
        this.setState({
            [name]: arr
        }, () => {
            callback(true);
        })
    }
    // [{ user_id:**, role_id:**}, { user_id:**, role_id:**}]
    mergeLeaderMember(leaders, Members) {
        const { leaderId, memberId } = this.state;
        let arr = [];
        for (const item of leaders) {
            let obj = {
                user_id: item.id,
                role_id: leaderId
            }
            arr.push(obj)
        }
        for (const item of Members) {
            let obj = {
                user_id: item.id,
                role_id: memberId
            }
            arr.push(obj)
        }
        return arr;
    }
    //name: role name字段
    filterRole(members, name) {
        if (members) {
            if (members.length <= 0) return [];
            let leaderArr = [];
            let memberArr = [];
            for (const obj of members) {
                let roleObj = obj.role;
                if (roleObj.name === LEADER) {
                    leaderArr.push(obj);
                } else {
                    memberArr.push(obj)
                }
            }
            if (name === LEADER) return leaderArr;
            if (name === MEMBER) return memberArr;
        }
        return [];
    }
    //----------------request-------------------------------
    getUsers(callback) {
        let params = {
            page_index: 1,
            page_size: 100
        }
        instance.get(BASE_URL + 'users', { params }).then((res) => {
            let users = res.data.data
            console.log("user", users)
            this.setState({
                users
            }, () => {
                callback();
            });
        })
    }
    getRole(callback) {
        instance.get(BASE_URL + 'admin/roles').then((res) => {
            let roles = res.data.data;
            let leaderId = 0;
            let memberId = 0;
            console.log("roles", res)
            for (const obj of roles) {
                if (obj.name === LEADER) {
                    leaderId = obj.id;
                } else if (obj.name === MEMBER) {
                    memberId = obj.id;
                }
            }
            this.setState({
                leaderId,
                memberId
            }, () => {
                callback();
            });
        })
    }
    //[ {user_id:**,  role_id:**}, {user_id:**,  role_id:**}]
    addMember(members, team_id) {
        const params = {
            members
        }
        instance.post(BASE_URL + 'department/teams/' + team_id + '/members', params).then((res) => {
            this.showToast("Added successfully", "success");
            console.log("addMember", res);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    //[ {user_id:**,  role_id:**}, {user_id:**,  role_id:**}]
    delMember(members, team_id, callback) {
        console.log(members)
        const params = {
            members
        }
        console.log(params)
        instance.delete(BASE_URL + 'department/teams/' + team_id + '/members', { data: params }).then((res) => {
            this.showToast("Successfully deleted", "success");
            console.log("delMember", res);
            callback()
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default TeamInfo;